import Pusher from 'pusher-js'

declare global {
  // tslint:disable-next-line interface-name
  interface Window {
    fotballVm2018: Pusher.Pusher
  }
}

export class PusherManager {
  public pusher: Pusher.Pusher
  public channelNames: string[] = []

  constructor(appKey: string, cluster: string) {
    if (typeof window !== 'undefined') {
      if (window.fotballVm2018) {
        this.pusher = window.fotballVm2018
      } else {
        this.pusher = window.fotballVm2018 = new Pusher(appKey, {
          cluster,
          encrypted: true
        })
      }
    } else {
      this.pusher = new Pusher(appKey, {
        cluster,
        encrypted: true
      })
    }
  }

  public subscribe(channelName: string, onUpdate: (arg: any) => void) {
    if (this.channelNames.includes(channelName)) {
      return
    }

    if (channelName && onUpdate) {
      this.pusher.subscribe(channelName).bind('update', onUpdate)
      this.channelNames.push(channelName)
    }
  }

  public disconnect() {
    // bind listening to disconnect
  }

  public unsubscribe(channelName: string) {
    if (this.channelNames.includes(channelName)) {
      this.pusher.unsubscribe(channelName)
      this.channelNames = this.channelNames.filter(c => c !== channelName)
    }
  }
  public unsubscribeAll() {
    this.channelNames.forEach(channelName => {
      this.pusher.unsubscribe(channelName)
    })
    this.channelNames = []
  }
}
